import React, { createContext, useContext } from 'react'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { useAuthDataContext } from './Auth'

export const SocketContext = createContext({})

window.Pusher = Pusher

Pusher.logToConsole = true

let listener

const SocketProvider = props => {
    const auth = useAuthDataContext()

    if (auth && auth.data) {
        if (!listener) {
            let token = auth.data.access_token

            listener = new Echo({
                broadcaster: 'reverb',
                key: process.env.REACT_APP_REVERB_APP_KEY,
                wsHost: process.env.REACT_APP_REVERB_HOST,
                wsPort: process.env.REACT_APP_REVERB_PORT,
                wssPort: process.env.REACT_APP_REVERB_PORT,
                forceTLS: false,
                enabledTransports: ['ws', 'wss'],
                authEndpoint: process.env.REACT_APP_API_URL + 'api/broadcasting/auth',
                auth: {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                },
            })

            console.log(listener)
        }
    }

    return <SocketContext.Provider value={listener} {...props} />

}

export const useSocketContext = () => useContext(SocketContext)

export default SocketProvider
